import { Component, Prop, Element, h } from '@stencil/core';
import LinkDecorator from '../_common/link-decorator/_link-decorator';

/**
 * @description A basic text link, for use in body copy. Wraps an anchor tag.
 * @use
 * @since 5.21.0
 * @slot - `default slot`: The body or content text of the link.
 * @ssh
 * @version figma-v1
 */
@Component({
  tag: 'hp6-link-text-basic',
  styleUrl: 'link-text-basic.scss',
  shadow: false, // NOTE: shadow not required, no content around slot
})
export class LinkTextBasic {
  /**
   * If true, link uses inverted style
   */
  @Prop({ reflect: true }) isInverted: boolean = false;

  /**
   * The text size of the link. By default, inherits the text size of its DOM parent.
   */
  @Prop({ reflect: true }) sizeSelection: 'inherit' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    = 'inherit';

  /**
   * Appended to allyLabel if target is blank
   */
  @Prop() newWindowText: string = ', opens in new window';

  @Element() host: HTMLElement;

  /**
   * The list of classes to apply to the anchor, space separated
   */
  get classList(): string {
    const { isInverted } = this;
    return `hp-link-text-basic${isInverted ? ' inverted' : ''}`;
  }

  render() {
    const { host, newWindowText, classList } = this;

    return (
      <LinkDecorator host={host} newWindowText={newWindowText} classList={classList}>
        <slot />
      </LinkDecorator>
    );
  }
}
